// generated using "cd ~/code/pinboard/webapp/locale/ && node ./generateLocaleData.js"
require('intl/locale-data/jsonp/ro-RO.js');
var localeData = {
  locale: 'ro-RO',
  i18nStrings: require('./messages-js.json'),
  plural: require('./plural.js')
};

module.exports = localeData;
